import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { siteData } from "../mock";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
     
  }, []); // scroll listener setup - runs once on mount

  const links = [
    { to: "/", label: "Accueil" },
    { to: "/fasciathérapie-toulouse", label: "Fasciathérapie" },
    { to: "/coach-domicile", label: "Sport santé" },
    { to: "/tarifs", label: "Tarifs" },
    { to: "/blog", label: "Blog" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#fdfaf5]/90 backdrop-blur-md border-b border-[#eee5d6]" : "bg-transparent"
      }`}
    >
      <div className="container-tight flex items-center justify-between h-20">
        <Link to="/" className="flex items-center">
          <div className="leading-tight">
            <div className="font-serif text-[19px] font-semibold text-[#2b2620]">Fasciathérapie</div>
            <div className="text-[11px] tracking-[0.15em] text-[#c76d4b] font-medium uppercase">& Sport Santé</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `text-[14px] font-medium transition-colors ${
                  isActive ? "text-[#c76d4b]" : "text-[#2b2620] hover:text-[#c76d4b]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a href={`tel:${siteData.practitioner.phone.replace(/\s/g, "")}`} className="btn-outline !py-2 !px-4">
            <Phone size={16} /> {siteData.practitioner.phone}
          </a>
          <a
            href="https://www.resalib.fr/praticien/120570-jean-christophe-happillon-fasciatherapeute-quint-fonsegrives"
            target="_blank"
            rel="noreferrer"
            className="btn-primary"
          >
            Prendre RDV
          </a>
        </div>

        <button className="lg:hidden text-[#2b2620]" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#fdfaf5] border-t border-[#eee5d6] px-6 py-6">
          <div className="flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-[#2b2620]"
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href="https://www.resalib.fr/praticien/120570-jean-christophe-happillon-fasciatherapeute-quint-fonsegrives"
              target="_blank"
              rel="noreferrer"
              className="btn-primary justify-center mt-2"
            >
              Prendre RDV
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
